/* MOSAMY single-image product lightbox */
if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
    }
    setupGallery() {
      if (this.galleryReady) return;
      this.galleryReady = true;
      this.content = this.querySelector('[role="document"]');
      this.items = Array.from(this.content.children).filter(item => item.hasAttribute('data-media-id'));
      const style = document.createElement('style');
      style.textContent = `
        product-modal.mosamy-lightbox[open]{position:fixed;inset:0;z-index:1000;background:rgba(0,0,0,.88)}
        .mosamy-lightbox .product-media-modal__dialog{height:100%;width:100%;margin:0;background:transparent}
        .mosamy-lightbox .product-media-modal__content{position:absolute;inset:0;margin:0!important;padding:65px 64px!important;height:100%;width:100%;box-sizing:border-box;overflow:hidden;background:transparent;display:flex;align-items:center;justify-content:center}
        .mosamy-lightbox .product-media-modal__content > [data-media-id]{display:none!important;margin:0!important}
        .mosamy-lightbox .product-media-modal__content > [data-media-id].active{display:block!important;max-width:100%!important;max-height:100%!important;width:auto!important;height:auto!important;object-fit:contain}
        .mosamy-lightbox .product-media-modal__toggle{position:absolute;top:14px;right:16px;z-index:5;background:#fff;color:#222}
        .mosamy-gallery-arrow{position:absolute;top:50%;transform:translateY(-50%);z-index:5;width:44px;height:44px;border:0;border-radius:50%;background:#fff;color:#222;font-size:30px;line-height:1;cursor:pointer}
        .mosamy-gallery-prev{left:12px}.mosamy-gallery-next{right:12px}
        .mosamy-gallery-count{position:absolute;bottom:15px;left:50%;transform:translateX(-50%);color:white;z-index:5;font-size:14px}
        @media(max-width:749px){.mosamy-lightbox .product-media-modal__content{padding:65px 48px!important}.mosamy-gallery-arrow{width:36px;height:36px}.mosamy-gallery-prev{left:6px}.mosamy-gallery-next{right:6px}}
      `;
      this.appendChild(style);
      this.classList.add('mosamy-lightbox');
      const dialog = this.querySelector('[role="dialog"]');
      for (const [direction, label, glyph, delta] of [['prev','Previous image','‹',-1],['next','Next image','›',1]]) {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'mosamy-gallery-arrow mosamy-gallery-' + direction;
        button.setAttribute('aria-label', label);
        button.textContent = glyph;
        button.addEventListener('pointerup', event => event.stopPropagation());
        button.addEventListener('click', event => { event.stopPropagation(); this.move(delta); });
        button.hidden = this.items.length < 2;
        dialog.appendChild(button);
      }
      this.counter = document.createElement('span');
      this.counter.className = 'mosamy-gallery-count';
      this.counter.setAttribute('aria-live','polite');
      dialog.appendChild(this.counter);
      this.content.addEventListener('pointerup', event => {
        if (event.target.closest('[data-media-id]')) event.stopPropagation();
      });
      this.content.addEventListener('touchstart', event => { this.touchX = event.changedTouches[0].clientX; }, {passive:true});
      this.content.addEventListener('touchend', event => {
        const distance = event.changedTouches[0].clientX - this.touchX;
        if (Math.abs(distance) > 45) this.move(distance > 0 ? -1 : 1);
      }, {passive:true});
    }
    show(opener) {
      this.setupGallery();
      super.show(opener);
      this.index = Math.max(0,this.items.findIndex(item => item.dataset.mediaId === opener.getAttribute('data-media-id')));
      this.showActiveMedia();
    }
    move(delta) {
      this.index = (this.index + delta + this.items.length) % this.items.length;
      window.pauseAllMedia();
      this.showActiveMedia();
    }
    showActiveMedia() {
      this.items.forEach((item, index) => {
        const active = index === this.index;
        item.classList.toggle('active',active);
        item.setAttribute('aria-hidden', String(!active));
        if (active && item.nodeName === 'DEFERRED-MEDIA') item.loadContent();
      });
      this.counter.textContent = (this.index + 1) + ' / ' + this.items.length;
    }
  });
}
